import React from "react";

interface IconProps {
    width?: number;
    height?: number;
    color?: string;
    onClick?: () => void;
    className?: string;
    style?: React.CSSProperties;
}

const PackageIcon: React.FC<IconProps> = ({
    width = 25,
    height = 25,
    color = "rgb(69, 110, 141)",
    onClick = () => { },
    style,
    className,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 611.999 611.999"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            className={className}
            style={style}
        >
            <path
                d="M611.999,345.995v206.637c0,8.232-6.674,14.905-14.907,14.905h-64.767c-8.233,0-14.907-6.674-14.907-14.905v-26.537
        c-0.953,2.908-3.026,5.381-6.023,5.869c-64.779,10.567-133.56,47.779-201.934,47.779c-64.107,0-147.21-13.043-193.734-60.608
        C63.85,466.093,19.173,418.082,7.683,401.677c-23.327-33.303,11.571-61.878,36.684-35.521
        c21.318,22.373,67.54,71.537,102.792,95.611c5.152,22.292,35.018,43.6,65.385,43.6s173.076,0,173.076,0
        s-11.285-14.839-24.935-16.149c0,0-128.113,0-147.028,0c-18.916,0-51.186-15.478-51.186-49.87c0-41.271,34.85-49.869,51.186-49.869
        c12.355,0,90.083,0,127.253,0c0,0,49.01-34.394,95.438-34.394c35.645,0,64.699,12.669,76.277,18.555
        c2.317,1.178,3.969,3.214,4.795,5.585v-33.229c0-8.233,6.674-14.907,14.906-14.907h64.768
        C605.325,331.088,611.999,337.762,611.999,345.995z M153.906,409.791c-8.09-13.612-67.969-64.392-88.461-72.61
        c-16.761-6.722-20.565,7.855-20.565,7.855s88.596,76.987,95.81,83.256C149.348,426.179,157.635,416.065,153.906,409.791z
         M143.666,274.131V88.059c0-30.819,24.983-55.802,55.802-55.802h85.27v42.002h39.589V32.256h84.75
        c30.818,0,55.803,24.983,55.803,55.802v186.073c0,30.818-24.984,55.802-55.803,55.802h-85.548v-33.2h-37.163v33.2h-86.899
        C168.649,329.933,143.666,304.95,143.666,274.131z M251.54,175.511c1.152,0,18.728,0,39.452,0v84.694h30.402v-84.694
        c21.416,0,39.452,0,39.452,0l-54.653-65.15L251.54,175.511z M170.977,374.12c-8.09-13.612-49.369-45.79-69.861-54.01
        c-16.76-6.722-20.564,7.855-20.564,7.855s69.995,58.386,77.21,64.656C166.419,390.506,174.706,380.393,170.977,374.12z"
                fill={color}
            />
        </svg>
    );
};

export default PackageIcon;
